import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MedicalRecordState } from './medical-record.state';

export const MEDICAL_RECORD_STATE = 'medical_record';

const medicalRecord =
  createFeatureSelector<MedicalRecordState>(MEDICAL_RECORD_STATE);

export const getMedicalRecordState = createSelector(medicalRecord, (state) => {
  return state;
});

export const getPatientInformations = createSelector(medicalRecord, (state) => {
  return state.patient;
});

export const getHidePatientName = createSelector(medicalRecord, (state) => {
  return state.hidePatientName;
})

export const getAnamnesisSelect = createSelector(medicalRecord, (state) => {
  return state.anamnesis;
});

export const getEvolutionSelect = createSelector(medicalRecord, (state) => {
  return state.evolution;
});

export const getPhysicalExamSelect = createSelector(medicalRecord, (state) => {
  return state.physicalExam;
});

export const getToxicitySelect = createSelector(medicalRecord, (state) => {
  return state.toxicity;
});

export const getSolicitations = createSelector(medicalRecord, (state) => {
  return state.solicitations;
});

export const getSolicitationById = (id: string) => createSelector(medicalRecord, (state) => {
  return state.solicitations?.find(solicitation => solicitation.solicitationId === id);
});

export const getVitalSignsSelect = createSelector(medicalRecord, (state) => {
  return state.vitalSigns;
});

export const getConductSelect = createSelector(medicalRecord, (state) => {
  return state.conduct;
});

export const getDiagnoses = createSelector(medicalRecord, (state) => {
  return state.diagnoses;
});

export const getEducationSelect = createSelector(medicalRecord, (state) => {
  return state.education;
});

export const setEducationToday = createSelector(medicalRecord, (state) => {
  return state.education?.today;
});

export const getChemotherapyTreatment = createSelector(medicalRecord, (state) => {
  return state.chemotherapyPage;
});

export const getNursing = createSelector(medicalRecord, (state) => {
  return state.nursing;
});

export const getNursingHistory = createSelector(medicalRecord, (state) => {
  return state.nursingHistory;
});

export const getNursingAvaliation = createSelector(medicalRecord, (state) => {
  return state.nursingAvaliation;
});

export const getNursingDiagnosis = createSelector(medicalRecord, (state) => {
  return state.nursingDiagnostic;
});

export const getRamHistory = createSelector(medicalRecord, (state) => {
  return state.ram
})

export const getPharmacyHistory = createSelector(medicalRecord, (state) => {
  return state.pharmacy;
})

export const getPharmacyAttentionHistory = createSelector(medicalRecord, (state) => {
  return state.pharmacyAttention;
})

export const getPharmacyInterventionHistory = createSelector(medicalRecord, (state) => {
  return state.pharmacyIntervention;
})

export const getNutritionHistory = createSelector(medicalRecord, (state) => {
  return state.nutrition;
})

export const getPsychology = createSelector(medicalRecord, (state) => {
  return state.psychology;
})

export const getPsychologyAssessment = createSelector(medicalRecord, (state) => {
  return state.psychologyAssessment;
})

export const getPsychologyBackground = createSelector(medicalRecord, (state) => {
  return state.psychologyBackground;
})

export const getPsychologyEvolution = createSelector(medicalRecord, (state) => {
  return state.psychologyEvolution;
})

export const getPsychologyDistress = createSelector(medicalRecord, (state) => {
  return state.psychologyDistress;
})
